import { BaseService } from 'src/services/base'

export class StorageService extends BaseService {
  public static async upload(formData: object) {
    try {
      const res = await this.callAPI({
        method: 'post',
        url: `/api/v1/storage/upload-products-images/`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${this.getToken()}`,
        },
      })
      return this.getSuccessInfo(res)
    } catch (e) {
      return this.getErrorInfo(e)
    }
  }
}
